import Node from "../node/index.js"

export default class extends Node {}